import {
	STASH_LIST_GET,
	STASH_LIST_SUCCESS,
	STASH_UNAVAILABLE,
	STASH_CREATE,
	STASH_RESTORE,
	STASH_DELETE,
	STASH_CONTENT_GET,
	STASH_CONTENT_SUCCESS,
} from '../constants/patchMenu';

// Brouillons mis de côté sur la carte courante. `busy` couvre les trois
// écritures : créer et reprendre rechargent toute la carte, il ne faut pas
// pouvoir en lancer une seconde entre-temps.
//
// `content` est un cache indexé par identifiant de stash : replier puis
// rouvrir un détail ne relance aucune requête.
const initialState = {
	loading: false,
	loaded: false,
	busy: false,
	// La table tampon n'est pas créée par l'application : sur une base où elle
	// manque, la lecture échoue et la fonctionnalité disparaît de l'écran
	// plutôt que d'offrir des boutons qui ne mèneraient nulle part.
	available: true,
	list: [],
	content: {},
};

export default function stashReducer(state = initialState, action) {
	switch (action.type) {
		case STASH_LIST_GET:
			return { ...state, loading: true };
		case STASH_LIST_SUCCESS:
			// Le cache de détail repart à vide : reprendre ou supprimer fait
			// disparaître des stashes, et mettre de côté en crée un dont le
			// contenu n'a jamais été lu.
			return {
				...state,
				loading: false,
				loaded: true,
				busy: false,
				available: true,
				list: action.stashes,
				content: {},
			};
		case STASH_CONTENT_GET:
			return {
				...state,
				content: { ...state.content, [action.id]: { loading: true } },
			};
		case STASH_CONTENT_SUCCESS:
			return {
				...state,
				content: {
					...state.content,
					[action.id]: {
						loading: false,
						rows: action.rows,
						total: action.total,
						limit: action.limit,
					},
				},
			};
		case STASH_CREATE:
		case STASH_RESTORE:
		case STASH_DELETE:
			return { ...state, busy: true };
		case STASH_UNAVAILABLE:
			return {
				...state,
				loading: false,
				loaded: true,
				busy: false,
				available: false,
				list: [],
				content: {},
			};
		default:
			return state;
	}
}
